import { C as Cart } from './cart-DZS7CGyq.js';
import { P as PubSub } from './pubsub-COBwjfLh.js';
import { p as parseHTML } from './parseHTML-Om2c1Ayj.js';
import './uniq-BDEfcc0N.js';
import './notyf-DIw0RvBj.js';

class CartDrawerSummary extends HTMLElement {
  #unsubscribers = [];

  static {
    Cart.sections.push('fetch-cart-drawer-summary');
  }

  connectedCallback() {
    this.#unsubscribers.push(
      ...['cart:add', 'cart:update', 'cart:change'].map((event) =>
        PubSub.subscribe(event, (payload) => {
          this.#renderSection(payload?.sections);
        })
      ),
      PubSub.subscribe('cart:fetch', ({ status }) => this.#handleLoading(status === 'pending'))
    );
  }

  disconnectedCallback() {
    this.#unsubscribers.forEach((unsubscribe) => unsubscribe());
  }

  #renderSection(sections) {
    const sectionHtml = sections?.['fetch-cart-drawer-summary'];
    if (!sectionHtml) return;

    const html = parseHTML(sectionHtml);
    const target = html.querySelector('cart-drawer-summary');
    if (!target) return;

    const drawer = this.closest('drawer-element');
    const continueShoppingButton = target.querySelector('button[aria-controls="cart-drawer"]');

    if (continueShoppingButton && drawer) {
      continueShoppingButton.addEventListener('click', () => {
        drawer.getAttribute('aria-hidden') === 'true' ? drawer.open() : drawer.close();
      });
    }

    this.replaceWith(target);
  }

  #handleLoading(loading) {
    this.querySelectorAll('.button').forEach((button) => {
      button.classList.toggle('loading', loading);
    });
  }
}

customElements.define('cart-drawer-summary', CartDrawerSummary);
